/* -------------------------------------------------------------------------- */
/*                            react-select styling                            */
/* -------------------------------------------------------------------------- */

export default {
   placeholderColor: '#999999',
   searchColor: '#212529',
   noOptionsColor: '#212529',
   optionBackgroundColor: '#fff',
   optionFocusedBackgroundColor: '#DEE2E6',
   borderColors: '#E6E6E6',
   backgroundColor: 'white',
   disabledBackgroundColor: 'rgba(243, 244, 246, var(--tw-bg-opacity))',
   defaultBorderColors: 'rgba(229, 231, 235, var(--tw-border-opacity))',
   borderHoverColor: 'rgba(var(--primary) , var(--bg-opacity, 1))',
   focusedArrowColor: '#f7fafc',
   borderRadius: 5,
   successColor: '#00983F',
   errorColor: '#e53e3e',
};
